import React from 'react';
import { Box } from '@mui/material';
import ReactPlayer from 'react-player';

interface VideoFieldProps {
  playbackUrl: string;
}

const VideoField: React.FC<VideoFieldProps> = ({ playbackUrl }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: '56.25%', // 16:9 aspect ratio
        bgcolor: 'background.paper',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <ReactPlayer
          src={playbackUrl}
          width="100%"
          height="100%"
          controls
        />
      </Box>
    </Box>
  );
};

export default VideoField;
